import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $titleColor?: string;
  $noticeColor?: string;
  $hideBullet?: boolean;
}

export const ToggleNotice = styled.div<IProps>`
  text-align: left;

  &.active .btn svg {
    transform: rotate(180deg);
  }

  .btn {
    font-weight: 600;
    font-size: 13px;
    color: ${({ $titleColor }) => $titleColor};
    gap: 0 6px;

    svg path {
      stroke: ${({ $titleColor }) => $titleColor};
    }
  }

  .notice-wrap {
    color: ${({ $noticeColor }) => $noticeColor};
    padding-top: 16px;
    word-break: break-all;

    .text {
      position: relative;
      font-size: 13px;
      line-height: 130%;
      padding-left: ${({ $hideBullet }) => ($hideBullet ? '0' : '9px')};
      white-space: ${({ $hideBullet }) =>
        $hideBullet ? 'pre-line' : 'normal'};

      + .text {
        margin-top: 2px;
      }

      &:after {
        content: '';
        display: ${({ $hideBullet }) => ($hideBullet ? 'none' : 'block')};
        position: absolute;
        top: 8px;
        left: 0;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: ${({ $noticeColor }) => $noticeColor};
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      font-size: ${mixin.pxToVw('13')};
      gap: ${mixin.pxToVw('6')};

      svg {
        width: ${mixin.pxToVw('16')};
        height: ${mixin.pxToVw('16')};
      }
    }

    .notice-wrap {
      padding-top: ${mixin.pxToVw('16')};

      .text {
        font-size: ${mixin.pxToVw('13')};
        padding-left: ${({ $hideBullet }) =>
          $hideBullet ? '0' : mixin.pxToVw('9')};

        + .text {
          margin-top: ${mixin.pxToVw('2')};
        }

        &:after {
          top: ${mixin.pxToVw('8')};
          width: ${mixin.pxToVw('3')};
          height: ${mixin.pxToVw('3')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .notice-wrap {
      padding-top: 10px;

      .text + .text {
        margin-top: 2.5px;
      }
    }
  }
`;
